(() => {
  const init = (sectionEl) => {
    if (!sectionEl) return;
    if (sectionEl.dataset.bmfmInit === 'true') return;
    sectionEl.dataset.bmfmInit = 'true';

    const selectorName = sectionEl.dataset.selectorName;
    const layout = sectionEl.dataset.layout || 'carousel';
    const selectors = selectorName ? sectionEl.querySelectorAll(`[name="${CSS.escape(selectorName)}"]`) : [];
    if (!selectorName || selectors.length === 0) return;

    const getActiveHandle = () => {
      const checked = sectionEl.querySelector(`input[name="${CSS.escape(selectorName)}"]:checked`);
      if (checked && checked.value) return checked.value;
      const select = sectionEl.querySelector(`select[name="${CSS.escape(selectorName)}"]`);
      if (select && select.value) return select.value;
      return '';
    };

    const applyVisuals = (handle) => {
      if (!handle) return;

      const node = sectionEl.querySelector(`.bmfm-visual[data-collection="${CSS.escape(handle)}"]`);
      if (!node) return;

      let bgDesktop = node.getAttribute('data-bg-desktop') || '';
      let bgMobile = node.getAttribute('data-bg-mobile') || '';

      if (!bgDesktop && bgMobile) bgDesktop = bgMobile;
      if (!bgMobile && bgDesktop) bgMobile = bgDesktop;

      if (bgDesktop) sectionEl.style.setProperty('--bmfm-bg-image-desktop', `url("${bgDesktop}")`);
      else sectionEl.style.removeProperty('--bmfm-bg-image-desktop');

      if (bgMobile) sectionEl.style.setProperty('--bmfm-bg-image-mobile', `url("${bgMobile}")`);
      else sectionEl.style.removeProperty('--bmfm-bg-image-mobile');

      const logoDesktopEl = sectionEl.querySelector('.bmfm-logo-desktop');
      const logoMobileEl = sectionEl.querySelector('.bmfm-logo-mobile');

      if (logoDesktopEl) {
        const placeholder = node.getAttribute('data-logo-desktop-placeholder') || '';
        const srcset = node.getAttribute('data-logo-desktop-srcset') || '';
        const w = node.getAttribute('data-logo-desktop-width') || '';
        const h = node.getAttribute('data-logo-desktop-height') || '';

        if (srcset) {
          logoDesktopEl.hidden = false;
          if (w) logoDesktopEl.setAttribute('width', w);
          if (h) logoDesktopEl.setAttribute('height', h);
          logoDesktopEl.setAttribute('data-sizes', 'auto');
          logoDesktopEl.setAttribute('data-srcset', srcset);
          if (placeholder) logoDesktopEl.setAttribute('src', placeholder);

          logoDesktopEl.classList.add('lazyload');
          logoDesktopEl.classList.remove('lazyloaded');

          // Nudge lazysizes to process updated attributes immediately
          if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.unveil) {
            window.lazySizes.loader.unveil(logoDesktopEl);
          } else if (window.lazySizes && window.lazySizes.autoSizer && window.lazySizes.autoSizer.checkElems) {
            window.lazySizes.autoSizer.checkElems();
          }
        } else {
          logoDesktopEl.hidden = true;
          logoDesktopEl.removeAttribute('data-srcset');
          logoDesktopEl.removeAttribute('data-sizes');
        }
      }

      if (logoMobileEl) {
        const placeholder = node.getAttribute('data-logo-mobile-placeholder') || '';
        const srcset = node.getAttribute('data-logo-mobile-srcset') || '';
        const w = node.getAttribute('data-logo-mobile-width') || '';
        const h = node.getAttribute('data-logo-mobile-height') || '';

        if (srcset) {
          logoMobileEl.hidden = false;
          if (w) logoMobileEl.setAttribute('width', w);
          if (h) logoMobileEl.setAttribute('height', h);
          logoMobileEl.setAttribute('data-sizes', 'auto');
          logoMobileEl.setAttribute('data-srcset', srcset);
          if (placeholder) logoMobileEl.setAttribute('src', placeholder);

          logoMobileEl.classList.add('lazyload');
          logoMobileEl.classList.remove('lazyloaded');

          if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.unveil) {
            window.lazySizes.loader.unveil(logoMobileEl);
          } else if (window.lazySizes && window.lazySizes.autoSizer && window.lazySizes.autoSizer.checkElems) {
            window.lazySizes.autoSizer.checkElems();
          }
        } else {
          logoMobileEl.hidden = true;
          logoMobileEl.removeAttribute('data-srcset');
          logoMobileEl.removeAttribute('data-sizes');
        }
      }

      const xDesk = parseFloat(node.getAttribute('data-logo-x-desktop') || '0') || 0;
      const xMob = parseFloat(node.getAttribute('data-logo-x-mobile') || '0') || 0;
      sectionEl.style.setProperty('--bmfm-logo-x-desktop', `${xDesk}px`);
      sectionEl.style.setProperty('--bmfm-logo-x-mobile', `${xMob}px`);
    };

    const applyProducts = (handle) => {
      if (!handle) return;
      const buttons = sectionEl.querySelectorAll('.view-all-button');

      if (layout === 'grid') {
        const gridItems = sectionEl.querySelectorAll('.grid-item');
        gridItems.forEach((item) => {
          item.style.display = item.dataset.collection === handle ? '' : 'none';
        });
        buttons.forEach((button) => {
          button.style.display = button.dataset.collection === handle ? '' : 'none';
        });
      } else {
        const slides = sectionEl.querySelectorAll('.keen-slider-slide');
        slides.forEach((slide) => {
          slide.style.display = slide.dataset.collection === handle ? '' : 'none';
        });
        buttons.forEach((button) => {
          button.style.display = button.dataset.collection === handle ? '' : 'none';
        });
        const carousel = sectionEl.querySelector('component-carousel');
        if (carousel && carousel.sliderObj && carousel.sliderObj.refresh) carousel.sliderObj.refresh();
      }
    };

    selectors.forEach((el) => {
      el.addEventListener('change', () => {
        const handle = el.value;
        applyProducts(handle);
        applyVisuals(handle);
      });
    });

    const initial = getActiveHandle();
    if (initial) applyVisuals(initial);

    // Theme editor support (safe even outside design mode)
    sectionEl.addEventListener('shopify:block:select', (e) => {
      if (e.target && e.target.dataset && e.target.dataset.selectorValue) {
        const opt = sectionEl.querySelector(`option[value="${CSS.escape(e.target.dataset.selectorValue)}"]`);
        if (opt) {
          opt.selected = true;
          const select = opt.closest('select');
          if (select) select.dispatchEvent(new CustomEvent('change'));
        }
      } else if (e.target) {
        const radio = e.target.querySelector('input');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new CustomEvent('change'));
        }
      }
    });
  };

  const boot = (root = document) => {
    root.querySelectorAll?.('[data-bmfm-section]').forEach((sectionEl) => init(sectionEl));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target || document);
  });
})();
